import localScaleManager from "../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../helpers/tweensConfigs";
import SideMenuOverlay from "../sideMenuOverlay";

export class ReplayHandMenu {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.tableInfo = table.tableInfo;
    this.showMenu = false;
    this.pointerDown = false;
    this.icon = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "history-icon")
      .setOrigin(0);
    this.margin = 0;
    this.icon.setInteractive({ cursor: "pointer" });
    this.icon.on("pointerdown", this.onPointerDown, this);
    this.icon.on("pointerup", this.onPointerUp, this);

    this.registryName = "showReplayHandMenu";
    this.scene.registry.set(this.registryName, false);
    this.overlay = new SideMenuOverlay(scene, this.registryName);
  }
  onPointerDown() {
    this.pointerDown = true;
  }
  onPointerUp() {
    if (this.scene.isSceneObjectsInteractive && this.pointerDown) {
      this.showMenu = true;
      this.scene.registry.set(this.registryName, this.showMenu);
      this.overlay.show();
    }
    this.pointerDown = false;
  }
  changePosition(x) {
    const initPosition = this.margin;
    this.icon.setX(x + initPosition);
    this.overlay.reposition();
  }
  scrollTo(positionX) {
    const initPosition = this.margin;
    this.scene.tweens.add({
      targets: this.icon,
      x: initPosition + positionX,
      duration: tweenConfigs.camera.duration,
      ease: tweenConfigs.camera.ease,
      onComplete: () => {
        this.updateTable();
        this.overlay.reposition();
      },
    });
  }
  hide() {
    if (!this.showMenu) return;
    this.scene.registry.set(this.registryName, false);
    this.showMenu = false;
    this.overlay.hide();
  }
  /**
   * tamame object hayii k az table in object(this.table) estefade mikonn bayad update shavand..
   */
  updateTable() {
    this.table = this.scene.getVisitedTable();
    this.tableInfo = this.table.tableInfo;
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  positionControls(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    let iconSize = Math.min(width / 10, height / 10);
    localScaleManager.scaleSprite(this.icon, iconSize, iconSize, 0, 1, true);
    // localScaleManager.scaleSpriteTo(this.icon, iconScale);
    this.icon.setPosition(
      this.margin,
      this.scene.gameHeight - this.margin * 10
    );
    this.overlay.positionControls();
  }
  /**
   * @param width {number} table width
   * @param height {number} table height
   */
  reposition(width, height) {
    this.margin = this.scene.header.menu.menuMargin;
    this.icon.setPosition(
      this.margin,
      this.scene.gameHeight - this.margin * 10
    );
    this.overlay.reposition();
  }
}
